import {Component, OnInit} from '@angular/core';
import {PlantillasServices} from '../../services/plantillas.services';
import {PlantillaModel} from '../../models/plantilla.model';
import {NgxSpinnerService} from 'ngx-spinner';
import {CategoriaModel, SubcategoriaModel} from '../../models/categoria.model';
import {PreguntaModel} from '../../models/pregunta.model';
import {PreguntasServices} from '../../services/preguntas.services';
import {CategoriasServices} from '../../services/categorias.services';
import {forkJoin, Subscription} from 'rxjs';
import * as lodash from 'lodash';
import {ActivatedRoute} from '@angular/router';

@Component({
  'selector': 'plantillas-list',
  'templateUrl': '../../templates/admin/plantillas/plantillas.admin.template.html'
})
export class PlantillasAdminComponent implements OnInit {

  public listPlantillas: PlantillaModel[] = [];

  rows: any[] = [];

  columns = [
    {name: 'Nombre'},
    {name: 'Descripcion'},
    {name: 'Activo'}
  ];

  constructor(private ps: PlantillasServices, private spinner: NgxSpinnerService) {
  }

  ngOnInit(): void {
    this.spinner.show();
    this.ps.getAllPlantillas().subscribe((d: any) => {
      this.listPlantillas = d.data.plantillas;
      this.spinner.hide();

      this.updatePlantillas();
      this.spinner.hide();
    });
  }

  updatePlantillas() {
    this.rows = [];
    for (let p of this.listPlantillas) {
      this.rows.push({
        nombre: p.nombre,
        acciones: p,
        descripcion: p.descripcion,
        activo: p.activo
      });
    }

    this.rows = [...this.rows];
  }

  togglePlantillaActiva(id: any) {
    this.ps.togglePlantillaActiva(id);
    let plantilla = this.listPlantillas.find(p=> p._id == id);
    if(plantilla){
      plantilla.activo = !plantilla.activo;
      this.updatePlantillas();
    }
  }

}

@Component({
  'selector': 'plantillas-new',
  'templateUrl': '../../templates/admin/plantillas/plantillas.new.template.html'
})
export class PlantillaNewComponent implements OnInit {

  public plantilla: PlantillaModel = new PlantillaModel();

  listCategorias: CategoriaModel[] = [];
  tempCat: CategoriaModel[] = [];

  listSubcategorias: SubcategoriaModel[] = [];
  tempSubcat: SubcategoriaModel[] = [];
  listPreguntas: PreguntaModel[] = [];
  tempPreg: PreguntaModel[] = [];

  catAgreg: any[] = [];
  catSelect: any;

  subcatAgreg: any[] = [];
  subcatSelect: any;

  pregAgreg: any[] = [];
  pregSelect: any;

  subcatActual: any = '';


  constructor(private ps: PlantillasServices, private cs: CategoriasServices, private pregs: PreguntasServices, private spinner: NgxSpinnerService) {
  }

  ngOnInit(): void {
    this.spinner.show();

    let consultas = [];
    consultas.push(this.cs.getAllCategorias());
    consultas.push(this.cs.getAllSubCategorias());
    consultas.push(this.pregs.getAllPreguntas());

    forkJoin(consultas).subscribe((d: any) => {
      this.listCategorias = d[0].data.categorias;
      this.tempCat = d[0].data.categorias;
      this.tempSubcat = d[1].data.subcategorias;
      this.tempPreg = d[2].data.preguntas;
      this.spinner.hide();
    });
  }

  agregarCategorias() {

    this.listCategorias = this.listCategorias.filter(c => {
      let found = this.catSelect.find(cs => cs == c._id);

      if (found) {

        this.catAgreg.push({
          id: c._id,
          nombre: c.nombre,
          porcentaje: 0
        });

        this.listSubcategorias = lodash.union(this.listSubcategorias, this.tempSubcat.filter(s => s.categoria._id == c._id));

        //
        return false;
      } else
        return true;
    });

    this.catSelect = [];

  }

  quitarCategoria(id: any) {
    this.catAgreg = this.catAgreg.filter(c => c.id != id);

    let cat = this.tempCat.find(c => c._id == id);
    if (cat) {
      this.listCategorias.push(cat);
      this.listSubcategorias = this.listSubcategorias.filter(s => s.categoria._id != cat._id);
      this.subcatAgreg = this.subcatAgreg.filter(s => s.categoria != cat._id);
    }
  }

  agregarSubcategorias() {

    this.listSubcategorias = this.listSubcategorias.filter(s => {
      let found = this.subcatSelect.find(sc => sc == s._id);

      if (found) {

        this.subcatAgreg.push({
          id: s._id,
          nombre: s.nombre,
          categoria: s.categoria._id
        });
        return false;
      } else
        return true;
    });

    this.subcatSelect = [];

  }

  quitarSubcategoria(id: any) {
    this.subcatAgreg = this.subcatAgreg.filter(c => c.id != id);

    let subcat = this.tempSubcat.find(c => c._id == id);
    if (subcat)
      this.listSubcategorias.push(subcat);
  }

  subcatActSelect(id: any) {
    console.log(this.tempPreg);
    // this.listPreguntas = this.tempPreg.filter(p => p.subcategoria._id == id);
    this.listPreguntas = this.tempPreg.filter((p) =>{
      if(p.subcategoria == null){
        return false;
      }
      return p.subcategoria._id == id;
    });

    this.subcatActual = id;

    this.listPreguntas = this.listPreguntas.filter(p => {
      let found = this.pregAgreg.find(pa => pa.id == p._id);
      if (found)
        return false;
      else
        return true;
    });
  }

  agregarPreguntas() {
    this.listPreguntas = this.listPreguntas.filter(p => {
      let found = this.pregSelect.find(ps => ps == p._id);

      if (found) {
        this.pregAgreg.push({
          id: p._id,
          enunciado: p.enunciado,
          peso: 1,
          subcategoria: p.subcategoria._id
        });
        return false;
      } else
        return true;
    });

    this.pregSelect = [];
  }

  quitarPregunta(id: any) {
    this.pregAgreg = this.pregAgreg.filter(p => p.id != id);

    let preg = this.tempPreg.find(p => p._id == id);

    if (preg) {
      this.listPreguntas.push(preg);
    }
  }

  guardarPlantilla() {
    let porcentajes = 0;

    console.log(this.catAgreg);

    this.catAgreg.map(c => {
      porcentajes += c.porcentaje;
    });

    if (porcentajes != 100) {
      alert('Los porcentajes no suman el 100%');
      return;
    }

    this.plantilla.catActivas = this.catAgreg;
    this.plantilla.subcatActivas = this.subcatAgreg;
    this.plantilla.pregActivas = this.pregAgreg;

    console.log(this.plantilla);

    this.spinner.show();
    this.ps.newPlantilla(this.plantilla).subscribe(d => {
      this.spinner.hide();
    });
  }

}

@Component({
  'selector': 'plantillas-edit',
  'templateUrl': '../../templates/admin/plantillas/plantillas.edit.template.html'
})
export class PlantillaEditComponent implements OnInit {

  plantilla: PlantillaModel;

  listCategorias: CategoriaModel[] = [];
  tempCat: CategoriaModel[] = [];
  catSelect: any;
  catAgreg: any[] = [];

  listSubcategorias: SubcategoriaModel[] = [];
  tempSubcat: SubcategoriaModel[] = [];
  subcatAgreg: any[] = [];
  subcatSelect: any;

  isLoading = true;


  constructor(private ps: PlantillasServices, private spinner: NgxSpinnerService, private cs: CategoriasServices, private activeRouter: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.spinner.show();
    let id = this.activeRouter.snapshot.params.id;

    this.ps.obsGetPlantilla.subscribe(d => {
      this.plantilla = d.plantilla;
      console.log(d.plantilla);
    });

    let consultas = [];
    consultas.push(this.cs.getAllCategorias());
    consultas.push(this.cs.getAllSubCategorias());

    forkJoin(consultas).subscribe((d: any) => {
      this.listCategorias = d[0].data.categorias;
      this.tempCat = d[0].data.categorias;
      this.tempSubcat = d[1].data.subcategorias;
      // this.tempPreg = d[2].data.preguntas;
      this.spinner.hide();
      setTimeout(() => this.cargarDatosPlantilla(), 500);
      this.isLoading = false;
    });

    this.ps.getPlantilla(id);

  }

  cargarDatosPlantilla() {
    this.listCategorias = this.listCategorias.filter(c => {
      let found = this.plantilla.catActivas.find(cs => cs.id == c._id);

      if (found) {

        this.catAgreg.push({
          id: c._id,
          nombre: c.nombre,
          porcentaje: found.porcentaje
        });

        this.listSubcategorias = lodash.union(this.listSubcategorias, this.tempSubcat.filter(s => s.categoria._id == c._id));

        return false;
      } else
        return true;
    });

    this.catSelect = [];
  }

  agregarCategorias() {

    this.listCategorias = this.listCategorias.filter(c => {
      let found = this.catSelect.find(cs => cs == c._id);

      if (found) {

        this.catAgreg.push({
          id: c._id,
          nombre: c.nombre,
          porcentaje: 0
        });

        this.listSubcategorias = lodash.union(this.listSubcategorias, this.tempSubcat.filter(s => s.categoria._id == c._id));

        //
        return false;
      } else
        return true;
    });

    this.catSelect = [];

  }
}

